exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stats {\n  list-style: none;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.stats li {\n  list-style: none;\n  padding: 0 !important;\n  margin: 0 30px 0 0 !important;\n}\n.stats li:before {\n  content: \"\" !important;\n}\n.stats span {\n  display: block;\n}\n.stats .stat {\n  font-size: 42px;\n  font-weight: bold;\n}", ""]);

// exports
